export default __webpack_public_path__ + "static/media/Gynpro.7e9eb051.png";